// Distingue lo que teclea un lector keyboard-wedge de lo que teclea una persona, por longitud y ritmo.
// Un lector USB escribe con menos de 50 ms entre teclas; una persona tarda de 120 a 240 ms.

/** Una tecla imprimible con el instante en que llegó (`KeyboardEvent.timeStamp`). */
export interface Tecla {
  tecla: string;
  t: number;
}

/** Entre teclas de un lector: nadie teclea tres seguidas tan rápido. */
const RAPIDO_MS = 50;

/** Una pausa así separa una ráfaga de la siguiente: tomar y disparar el lector tarda más. */
export const PAUSA_MS = 300;

/** Suma la tecla a la ráfaga en curso, o empieza otra si llegó después de una pausa. */
export function sumarTecla(rafaga: Tecla[], tecla: Tecla, pausa = PAUSA_MS): Tecla[] {
  const ultima = rafaga[rafaga.length - 1];
  return ultima && tecla.t - ultima.t < pausa ? [...rafaga, tecla] : [tecla];
}

/** Más teclas seguidas de las que caben en el campo: es un código, venga a la velocidad que venga. */
export function excedeElCampo(rafaga: Tecla[], maxDigitos: number): boolean {
  return rafaga.length > maxDigitos;
}

/**
 * Al llegar Enter, si lo tecleado es un código leído: tres o más teclas, todas a ritmo de lector hasta el
 * Enter. En un campo numérico también cuenta una ráfaga con letras, que ninguna cantidad tiene.
 */
export function terminaEnLectura(
  rafaga: Tecla[],
  tEnter: number,
  { campoNumerico = false, rapido = RAPIDO_MS }: { campoNumerico?: boolean; rapido?: number } = {}
): boolean {
  if (rafaga.length < 3) return false;
  if (campoNumerico && rafaga.some((k) => !/\d/.test(k.tecla))) return true;
  const tiempos = [...rafaga.map((k) => k.t), tEnter];
  return tiempos.every((t, i) => i === 0 || t - tiempos[i - 1]! <= rapido);
}

export function textoDe(rafaga: Tecla[]): string {
  return rafaga.map((k) => k.tecla).join('');
}

/** Cifras de un monto que se teclea en el mostrador (hasta 9.999.999); un código de barras trae 8 o más. */
export const DIGITOS_DE_PLATA = 7;
